"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactstrap = require("reactstrap");

var DropdownElements = function DropdownElements(_ref) {
  var link = _ref.link,
      title = _ref.title,
      location = _ref.location,
      isElementVisible = _ref.isElementVisible; // const isActive = location.pathname === link;

  return isElementVisible ? _react["default"].createElement("a", {
    href: link
  }, _react["default"].createElement(_reactstrap.DropdownItem, null, title)) : null;
};

var _default = DropdownElements;
exports["default"] = _default;